import React from "react";

import * as Table from "ds/Table";

import * as S from "./LogsExplorerProjectsList.styles";

const LogsExplorerProjectsList = () => {
  const projects = [
    {
      name: "chatbot.private.blackfire.io",
      obsSandboxUrl: "/blackfire/v5yh3bw6hcd3e/prod/observability-sandbox",
      vendor: "upsun",
      kind: "grid"
    },
    {
      name: "traffic",
      obsSandboxUrl: "/blackfire/gh4oqhk76tvwm/prod/observability-sandbox",
      vendor: "upsun",
      kind: "grid"
    },
    {
      name: "upsun.fastly.docs.blackfire.io",
      obsSandboxUrl: "/blackfire/6fkmp3eo2luu4/staging/observability-sandbox",
      vendor: "upsun",
      kind: "grid"
    },
    {
      name: "eu3.docs.blackfire.io",
      obsSandboxUrl: "/blackfire/golxovzgy3a62/staging/observability-sandbox",
      vendor: "upsun",
      kind: "grid"
    },
    {
      name: "blackfire-shopware-demo",
      obsSandboxUrl: "/blackfire/hxqv7nmzgjcfg/main/observability-sandbox",
      vendor: "upsun",
      kind: "grid"
    },
    {
      name: "private.blackfire.io",
      obsSandboxUrl: "/blackfire/t6gis6ld4fisc/prod/observability-sandbox",
      vendor: "upsun",
      kind: "grid"
    },
    {
      name: "www.blackfire.io",
      obsSandboxUrl: "/blackfire/5m2qgtfd6hedi/prod/observability-sandbox",
      vendor: "platformsh",
      kind: "grid"
    },
    {
      name: "fastly.docs.blackfire.io",
      obsSandboxUrl: "/blackfire/zn2qgxy72lorc/staging/observability-sandbox",
      vendor: "platformsh",
      kind: "grid"
    },
    {
      name: "dg3.www.blackfire.io",
      obsSandboxUrl: "/blackfire/yljejh3oxyzus/prod/observability-sandbox",
      vendor: "platformsh",
      kind: "dg3"
    },
    {
      name: "dg3.fastly.docs.blackfire.io",
      obsSandboxUrl: "/blackfire/q2smpygw4gwmu/staging/observability-sandbox",
      vendor: "platformsh",
      kind: "dg3"
    },
    {
      name: "dg3.docs.blackfire.io",
      obsSandboxUrl: "/blackfire/4lvuzsnyaxe4y/prod/observability-sandbox",
      vendor: "platformsh",
      kind: "dg3"
    },
    {
      name: "dg2.fastly.docs.blackfire.io",
      obsSandboxUrl: "/blackfire/7ntrflppq2wi6/staging/observability-sandbox",
      vendor: "platformsh",
      kind: "dg2"
    },
    {
      name: "dg2.docs.blackfire.io",
      obsSandboxUrl: "/blackfire/nqizrtbwjrc2k/prod/observability-sandbox",
      vendor: "platformsh",
      kind: "dg2"
    },
    {
      name: "blog.blackfire.io",
      obsSandboxUrl: "/blackfire/ohppb3vrezyog/master/observability-sandbox",
      vendor: "platformsh",
      kind: "grid"
    },
    {
      name: "Bigfoot example demo App",
      obsSandboxUrl: "/blackfire/pn4evultah3x6/main/observability-sandbox",
      vendor: "platformsh",
      kind: "grid"
    }
  ];

  const projectsPerVendor = {
    upsun: projects.filter(p => p.vendor === "upsun"),
    platformsh: projects.filter(p => p.vendor === "platformsh")
  };
  return (
    <S.TableWrapper>
      {Object.keys(projectsPerVendor).map(vendor => (
        <S.Column key={vendor}>
          <Table.Table>
            <Table.Thead>
              <Table.Th width="100%">{vendor}</Table.Th>
            </Table.Thead>
            <Table.Tbody>
              {projectsPerVendor[vendor].map(project => (
                <Table.Tr key={project.name} size="sm">
                  <Table.Td width="100%">
                    <a href={project.obsSandboxUrl}>
                      {project.name} [{project.kind}]
                    </a>
                  </Table.Td>
                </Table.Tr>
              ))}
            </Table.Tbody>
          </Table.Table>
        </S.Column>
      ))}
    </S.TableWrapper>
  );
};

export default LogsExplorerProjectsList;
